<label *ngIf="label" [for]="id">{{ label }}<em *ngIf="required">*</em>
  <ng-content select="ui-tip"></ng-content>
</label>
<ng-content select="sh-property-picker, ui-apartment-picker, .picker"></ng-content>
<ng-content></ng-content>
<div *ngIf="maxChars" class="count">{{ counter }} / {{ maxChars }}</div>
<small *ngIf="showHint && !!hint" class="form-text text-muted">{{ hint }}</small>
